import React from 'react'

import clsx from 'clsx'

import Grid from 'components/Grid'
import Icon from 'components/Icon'
import Typography from 'components/Typography'
import { formatRatingAverage } from 'helpers/formatters'

import classes from './Stars.module.scss'

/** @type {import("./types.d").default} */
const Stars = ({ className, classes: parentClass = {}, isCompact, rating, size, showAverageRating = false }) => {
  return (
    <Grid className={clsx('Stars', classes.ratingStarsContainer, showAverageRating && classes.WithUgcExp, className)}>
      {showAverageRating && (
        <Typography className={clsx(classes.average, 'RatingBase-average')} component="span" variant="tight-xs">
          {formatRatingAverage(rating)}
        </Typography>
      )}
      {isCompact ? (
        <Icon
          icon="star"
          className={clsx('Stars--active', rating ? classes.activeStar : classes.fadedStar)}
          size={size}
        />
      ) : (
        [1, 2, 3, 4, 5].map(i => {
          if (rating - (i - 1) >= 0.75) {
            return (
              <Icon
                icon="star"
                className={clsx('Stars--active', classes.activeStar, parentClass.activeStar)}
                key={i}
                size={size}
              />
            )
          }
          if (rating - (i - 1) >= 0.25) {
            return (
              <Icon
                icon="star-half"
                prefix="fad"
                className={clsx('Stars--half', classes.halfStar, parentClass.halfStar)}
                key={i}
                size={size}
              />
            )
          }
          return <Icon icon="star" className={clsx('Stars--faded', classes.fadedStar)} key={i} size={size} />
        })
      )}
    </Grid>
  )
}

export default Stars
